export default class CreateOrganizationError extends Error {

}
